import { EnsayoAdjuntoCard } from "./ensayo-adjunto-card";

export { EnsayoAdjuntoCard };
